// declare let JitsiMeetJS: object;

export default JitsiMeetJS;
